{
  "Electricity": {
    "name": "Electricity",
    "icon": "\uF46E",
    "bootstrapIcon": "bi-lightning-fill",
    "imagePath": "assets/images/icons/lightning.png",
    "color": "rgb(54, 121, 255, 0.8)",
    "costsColors": {
      "consumption": "rgb(54, 121, 255, 0.8)",
      "consumptionOffPeak": "rgb(0, 84, 217, 0.8)",
      "feedIn": "rgb(7, 205, 117, 0.8)",
      "feedInOffPeak": "rgb(0, 144, 56, 0.8)",
      "standingCharge": "rgb(147, 112, 219, 0.8)",
      "consumptionTax": "rgb(170, 186, 255, 0.8)"
    }
  },
  "Gas": {
    "name": "Gas",
    "icon": "\uF7F6",
    "bootstrapIcon": "bi-fire",
    "imagePath": "assets/images/icons/flame.png",
    "color": "rgb(255, 171, 0, 0.8)",
    "costsColors": {
      "consumption": "rgb(255, 171, 0, 0.8)",
      "standingCharge": "rgb(147, 112, 219, 0.8)",
      "consumptionTax": "rgb(255, 206, 123, 0.8)"
    }
  },
  "Heat": {
    "name": "Heat",
    "icon": "\uF5CE",
    "bootstrapIcon": "bi-thermometer-high",
    "imagePath": "assets/images/icons/thermometer.png",
    "color": "rgb(241, 81, 46, 0.8)",
    "costsColors": {
      "consumption": "rgb(241, 81, 46, 0.8)",
      "consumptionTax": "rgb(255, 140, 105, 0.8)"
    }
  },
  "Water": {
    "name": "Water",
    "icon": "\uF30B",
    "bootstrapIcon": "bi-droplet-fill",
    "imagePath": "assets/images/icons/drop.png",
    "color": "rgb(0, 184, 217, 0.8)",
    "costsColors": {
      "consumption": "rgb(0, 184, 217, 0.8)",
      "consumptionTax": "rgb(102, 215, 255, 0.8)"
    }
  },
  "Cooling": {
    "name": "Cooling",
    "icon": "\uF56E",
    "bootstrapIcon": "bi-snow2",
    "imagePath": "assets/images/icons/snowflake2.png",
    "color": "rgb(92, 184, 230, 0.8)",
    "costsColors": {
      "consumption": "rgb(92, 184, 230, 0.8)",
      "consumptionTax": "rgb(150, 217, 255, 0.8)"
    }
  },
  "ChargePoint": {
    "name": "ChargePoint",
    "icon": "\uD83D\uDD0C",
    "bootstrapIcon": "bi-ev-station",
    "imagePath": "assets/images/icons/green-plug.png",
    "color": "rgb(0, 150, 136, 0.8)",
    "costsColors": {
      "consumption": "rgb(92, 184, 230, 0.8)",
      "consumptionTax": "rgb(150, 217, 255, 0.8)"
    }
  }
}